import React from 'react';
import { UserContext } from '../constants';
export function Layout(props) {
    return (
        <UserContext.Provider value={JSON.parse(localStorage.getItem('user'))}>
            <div className="root-block">
                {props.children}
            </div>
        </UserContext.Provider>
    );
}